'use client'

import { createContext } from 'react'
import { useTabs } from './use-tabs'

export type TabsContextValue = ReturnType<typeof useTabs>

export const TabsContext = createContext({} as TabsContextValue)
